import NotFound from 'components/NotFound';
import AdminPatientsLogs from 'components/admin/pages/Patients/Logs';
import AdminPatientBasicInfo from 'components/admin/pages/Patients/PatientBasicInfo';
import AdminPatients from 'components/admin/pages/Patients/PatientsTable';
import AdminPatientsTransactions from 'components/admin/pages/Patients/Transaction/Transactions';
import PatientProfile from 'components/admin/pages/Patients/profile';

const ADMIN_PATIENTS = [
  {
    path: 'patients',
    element: <AdminPatients />,
    children: [
      {
        path: ':id',
        element: <PatientProfile />,
        children: [
          {
            path: '',
            element: <AdminPatientBasicInfo />
          },
          {
            path: 'logs',
            element: <AdminPatientsLogs />
          },
          {
            path: 'transactions',
            element: <AdminPatientsTransactions />
          },
          {
            path: '*',
            element: <NotFound />
          }
        ]
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];
export default ADMIN_PATIENTS;
